module.exports = __webpack_public_path__ + "img/scheme_bg.86928d15.svg";